import { defineNuxtPlugin } from '#app';
export default defineNuxtPlugin({
  name: 'dotlottie-player',
  parallel: true,
  setup(nuxtApp) {
    // Deliberately not awaited — registering must not block app init.
    import('@aarsteinmedia/dotlottie-player-light')
      .then(({ DotLottiePlayer }) => {
        nuxtApp.vueApp.component('DotLottiePlayer', DotLottiePlayer);
      })
      .catch(() => {
        // Animation is decorative — a failed load must not break the page.
      });
  },
});
